import React from 'react';
import { object } from 'prop-types';
import { BQLink } from '../../../atoms/bqlink';
import ListTitle from '../../../atoms/list-title';
import ListAuthor from '../../../atoms/list-author';

const StoryCardContentWithSummaryAuthor = ({ story, ...props }) => {
  const authorObj = story?.author_byline || '';
  return (
    <div>
      <div>
        <BQLink href={new URL(story?.link)?.pathname}>
          <ListTitle
            color={props.color}
            fontSize={props.fontSize}
            lineHeight={props.lineHeight}
            marginBottom="12px"
          >
            {story?.title}
          </ListTitle>
        </BQLink>
        <div className="summary">{story?.description}</div>
      </div>
      <div>
        <ListAuthor className="mt-4">{authorObj}</ListAuthor>
      </div>
    </div>
  );
};

StoryCardContentWithSummaryAuthor.propTypes = {
  story: object.isRequired,
};
StoryCardContentWithSummaryAuthor.defaultProps = {
  fontSize: 'var(--medium)',
  color: 'var(--second-color)',
  lineHeight: '1.2',
};

export default StoryCardContentWithSummaryAuthor;
